(function () {
  'use strict';

  /* @ngdoc object
   * @name pdfprinter
   * @description
   *
   */
  angular
    .module('pdfprinter', [
      'ui.router'
    ]);
}());
